import createClient from "openapi-fetch";
import type { paths } from "../../__definitions__/huddle.changeengine.com-definitions";
import { serviceURL } from "../../utils/service-url";

export const huddle = createClient<paths>({
  baseUrl: serviceURL("huddle"),
  headers: {
    "Content-Type": "application/json",
  },
});
